import React from 'react';
import PropTypes from 'prop-types';
import styles from '../header.scss';
import { t } from '../../../services/i18nService';
import navigationService from '../../../services/NavigationService';

const MessageButton = ({ isDisabled }) => {
    return (<button
        className={styles.messagesButton}
        onClick={navigationService.navigateToMessages}
        id="messagesMenuButton"
        disabled={isDisabled}
    >
        <span className={styles.icon}>
            <span className="sr-only">{t('header.messages')}</span>
            <i className="fa fa-bell-o fa-3" aria-hidden="true" />
        </span>
    </button>);
};

MessageButton.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
};

export default MessageButton;
